import { render } from "./button-group.vue?vue&type=template&id=61364492"
import script from "./button-group.vue?vue&type=script&lang=js"
export * from "./button-group.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./button.module.less?vue&type=style&index=0&lang=less&module=true&external"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./button-group.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__